import { isServer } from './dom';

export const raf = (() => {
  if (isServer) {
    return;
  }
  return window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.oRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    function(callback) {
      window.setTimeout(callback, 1000 / 60);
    };
})();

export function createScroll() {
  let isScrolling = false;
  let stop = false;

  if (!isServer) {
    document.addEventListener('visibilitychange', visibilityHandler);
  }

  function visibilityHandler() {
    if (!document.hidden) {
      isScrolling = false;
      stop = false;
    }
  }

  return function(el, type, targetPos, time, next) {
    if (isScrolling) {
      stop = true;
    }
    isScrolling = true;
    const start = Date.now();
    const currentPos = el[type];

    setTimeout(() => {
      raf(step);
    }, 0);

    function step() {
      const current = Date.now();
      const rate = Math.min(1, (current - start) / time);
      if (rate === 1) {
        el[type] = targetPos;
        isScrolling = false;
        next && next();
        document.removeEventListener('visibilitychange', visibilityHandler);
      } else {
        el[type] = currentPos + (targetPos - currentPos) * rate;
        if (!stop) {
          raf(step);
        } else {
          stop = false;
        }
      }
    }
  };
}
